import { action, makeObservable, observable, runInAction } from "mobx";
import apiService from "./apiService";
import type { SkillDto } from "@components/SkillEditDialog";

export type { SkillDto };

/** Cached list of the current user's skills, shared across the Skills settings tab and the "/" slash-command menu. */
class SkillService {
  @observable skills: SkillDto[] = [];
  @observable loaded: boolean = false;
  private _loadPromise: Promise<void> | null = null;

  constructor() {
    makeObservable(this);
  }

  /** Loads (or reloads, when force=true) the skill list from the server. Safe to call multiple times concurrently. */
  public loadSkills = async (force: boolean = false): Promise<void> => {
    if (this.loaded && !force) return;
    if (this._loadPromise) return this._loadPromise;

    this._loadPromise = (async () => {
      const skills = await apiService.get<SkillDto[]>('/api/skills');
      runInAction(() => {
        this.skills = skills;
        this.loaded = true;
      });
    })();

    try {
      await this._loadPromise;
    } finally {
      this._loadPromise = null;
    }
  };

  @action
  public invalidate(): void {
    this.loaded = false;
  }
}

export const skillService = new SkillService();
export default skillService;
